import { triggerEvent } from './../utils/Utils.js';

export const LanguageSwitcherController = () => {
    $('.m-localization-header .disclosure__toggle').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).next().toggleClass('disclosure-list--visible');
    });

    $('.m-localization-header .disclosure-list__item').on('click', (e) => {
        var value = $(e.currentTarget).data('value');

        if (value) {
          e.preventDefault();
          triggerEvent(document.querySelector('#localization_form .disclosure-list__item[data-value="'+value+'"]'), 'click');
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/controllers/LanguageSwitcherController.js